import React, { useRef, useState,useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { useAuth } from "../../../AuthProvider";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { toast ,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from "react-router-dom";





/* ──────────────────────────────────────────────────────────────── */
/* 60 demo rows – swap for your API                                */
/* ──────────────────────────────────────────────────────────────── */
const mockSaleItems = Array.from({ length: 50 }).map((_, i) => ({
  items: ["Laptop", "Keyboard", "Mouse"][i % 3],
  qty: 100 + i,
  priceItem: [2000, 500, 100][i % 3],
  purchaseAmount: [200000, 50000, 10000][i % 3]
}));



/* ──────────────────────────────────────────────────────────────── */
const baseUrl = process.env.REACT_APP_API_BASE_URL
export default function SoldItemsTemplate() {
//   const [saleItems] = useState(mockSaleItems);


   const componentRef = useRef();
    const location = useLocation();
    const scrollRef = useRef(null);
   
  //   const { billNo } = useParams(); 
  //   console.log("Received billNo:", billNo);
  
  //   const {soldItemData}=location.state || {}
    
  
  // const purchaseInvoice = location?.state?.purchaseInvoice;

   const { billNo } = useParams(); 
  console.log("Received billNo:", billNo);

  const soldItemData = location.state?.soldItemData;

  
    const [saleItems, setSaleItems] = useState([]); //TABLE API
  
  
    const navigate =useNavigate();

  const handlePrint = useReactToPrint({
    documentTitle: "Purchase_BillReceipt",
    content: () => componentRef.current
  });


const { oId ,board} = useAuth();
 const [companyInfo, setCompanyInfo] = useState({
    schoolName: "",
    pincode: "",
    primaryContact: "",
    secondaryContact: "",
    boardAffiliation: "",
    schoolAddress: "",
    affiliationNumber: "",
    city: "",
    state: "",
    schoolEmailId: "",
    schoolLogo: null,
    schoolStamp: null,
  });
  const [tempInfo, setTempInfo] = useState({ ...companyInfo });
  const [orgloading, setOrgLoading] = useState(true); 


  //organization details api 
    useEffect(() => {
      const fetchCompanyInfo = async () => {
        try {
          const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          
  
          const data = await response.json();
          setCompanyInfo({
            schoolLogo: data.schoolLogo,
            schoolStamp:data.schoolStamp,
            schoolName: data.schoolName,
            city: data.city,
            state: data.state,
            affiliationNumber: data.affiliationNumber,
            schoolAddress: data.schoolAddress,
            primaryContact: data.primaryContact,
            boardAffiliation: data.boardAffiliation,
            secondaryContact: data.secondaryContact,
            pincode: data.pincode,
            schoolEmailId: data.schoolEmailId,
          });
          setTempInfo(data);
  
          setOrgLoading(false); // Data fetched, stop loading
  
        } catch (error) {
          console.error("Error fetching company info:", error);
          setOrgLoading(false); // Stop loading even if there's an error
        }
      };
  
      fetchCompanyInfo();
    }, []);



    //  TABLE GET METHOD
    // const fetchTableData = async (purchaseInvoice, oId) => {
    //     if (!purchaseInvoice || !oId) {
    //       console.warn("Missing purchaseInvoice or organization ID (oId).");
    //       return;
    //     }
    
    //     try {
    //       const response = await fetch(
    //         `${baseUrl}/api/purchase/getAllItemsBasedOnInvoice/${purchaseInvoice}/${oId}`
    //       );
    
    //       if (!response.ok) {
    //         console.error("Failed to fetch table data:", response.statusText);
    //         return;
    //       }
    
    //       const data = await response.json();
    //       setSaleItems(data);
    //     } catch (error) {
    //       console.error("Error fetching table data:", error);
    //     }
    //   };
    
    //   useEffect(() => {
       
    
    //     if (soldItemData && oId) {
    //       fetchTableData(soldItemData, oId);
    //     }
    //   }, [soldItemData, oId]);

const fetchTableData = async (billNo) => {
  if (!billNo) {
    console.warn("No billNo provided to fetchTableData.");
    return;
  }

  try {
    const response = await fetch(`${baseUrl}/api/soldItems/getAllSoldBillInvoiceItems/bill/${billNo}`);

    if (!response.ok) {
      console.error('Failed to fetch table data:', response.statusText);
      return;
    }

    const data = await response.json();
    setSaleItems(data); // Store fetched data in state
  } catch (error) {
    console.error('Error fetching table data:', error);
  }
};





  useEffect(() => {
    fetchTableData(billNo)
  }, [billNo]);









        function convertNumberToWords(num) {
    const words = [
      "Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen",
      "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    if (num === 0) return words[0];
  
    function convertHundreds(n) {
      let result = "";
      if (n > 99) {
        result += words[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n > 19) {
        result += words[20 + Math.floor(n / 10) - 2] + (n % 10 !== 0 ? " " + words[n % 10] : "");
      } else if (n > 0) {
        result += words[n];
      }
      return result.trim();
    }
  
    function convertThousands(n) {
      if (n >= 1000) {
        return convertHundreds(Math.floor(n / 1000)) + " Thousand " + convertHundreds(n % 1000);
      } else {
        return convertHundreds(n);
      }
    }
  
    let integerPart = Math.floor(num); // Integer part of the number
    let decimalPart = Math.round((num - integerPart) * 100); // Fractional part (up to 2 decimal places)
  
    let result = "";
  
    // Process Crore
    if (integerPart >= 1e7) {
      result += convertThousands(Math.floor(integerPart / 1e7)) + " Crore ";
      integerPart %= 1e7;
    }
  
    // Process Lakh
    if (integerPart >= 1e5) {
      result += convertThousands(Math.floor(integerPart / 1e5)) + " Lakh ";
      integerPart %= 1e5;
    }
  
    // Process Thousand
    if (integerPart >= 1000) {
      result += convertThousands(Math.floor(integerPart / 1000)) + " Thousand ";
      integerPart %= 1000;
    }
  
    // Process Remaining Hundreds, Tens, and Ones
    if (integerPart > 0) {
      result += convertHundreds(integerPart);
    }
  
    // Handle decimal part if it exists
    if (decimalPart > 0) {
      result += " and " + convertHundreds(decimalPart) + " Paise";
    }
  
    return result.trim();
  }




// function registerFont(doc) {
//   doc.addFileToVFS("NotoSans-Regular.ttf", NotoSansNormal);
//   doc.addFont("NotoSans-Regular.ttf", "NotoSans", "normal");
//   doc.setFont("NotoSans"); // set as default font
// }

const addImageFromUrl = (doc, url, x, y, w, h, isCircular = false) =>
  new Promise((resolve) => {
    if (!url) return resolve();

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      const size = Math.min(img.width, img.height); // Ensure square canvas
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext("2d");

      if (isCircular) {
        const centerX = size / 2;
        const centerY = size / 2;
        const radius = size / 2;

        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.clip();
      }

      // Draw image centered in square canvas
      const offsetX = (img.width - size) / 2;
      const offsetY = (img.height - size) / 2;
      ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, size, size);

      doc.addImage(canvas.toDataURL("image/png"), "PNG", x, y, w, h);
      resolve();
    };

    img.onerror = () => resolve();
    img.src = url;
  });



const handleDownload = async (soldItemData,saleItems, companyInfo) => {
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // --- Header ---
  doc.setFontSize(10).text("Bill Receipt", pageWidth / 2, 10, { align: "center" });

  // School logo at top-left
 await addImageFromUrl(
  doc,
  companyInfo.schoolLogo && `data:image/jpeg;base64,${companyInfo.schoolLogo}`,
  15,
  20,
  25,
  25,
  true // <- this enables the circular clipping
);

  doc.setFontSize(12)
    .setFont("helvetica", "bold")
    .setTextColor(220, 20, 60)
    .text(`${companyInfo.schoolName}`, pageWidth / 2, 26, { align: "center" });

  doc.setFontSize(9)
    .setFont("helvetica", "normal")
    .setTextColor(0)
    .text(
      [
        `${[companyInfo.schoolAddress, companyInfo.city].filter(Boolean).join(', ')}`,
        `${[companyInfo.state, companyInfo.pincode].filter(Boolean).join(', ')}`,
        `${companyInfo.schoolEmailId}, ${companyInfo.primaryContact}`,
      ],
      pageWidth / 2,
      32,
      { align: "center", maxWidth: pageWidth - 80 }
    );

  // --- Company / Bill Details ---
  const companyStartY = 52;
  const rightX = pageWidth - 80;

  const fullName = [soldItemData?.studentFirstName, soldItemData?.studentLastName]
  .filter(Boolean)
  .join(' ') || "-";

  doc.setFontSize(11).setFont("helvetica", "bold").text("Student Details:", 15, companyStartY);
  doc.setFont("helvetica", "normal").setFontSize(9);
  // doc.text(`Student Name: ${soldItemData?.studentFirstName || "-"} ${soldItemData?.studentLastName || "-"}`, 15, companyStartY + 6);
  doc.text(`Student Name: ${fullName}`, 15, companyStartY + 6);
  doc.text(`Class: ${`${soldItemData?.romanNumberClass || ""}`}`, 15, companyStartY + 12);
   doc.text(`Section: ${soldItemData?.sections || "-"}`, 15, companyStartY + 18);

  doc.setFontSize(10).setFont("helvetica", "bold").text("Bill Details:", rightX, companyStartY);
  doc.setFont("helvetica", "normal").setFontSize(9);
  doc.text(`Bill No: ${soldItemData?.billNo}`, rightX, companyStartY + 6);
  doc.text(`Bill Date: ${soldItemData?.date}`, rightX, companyStartY + 12);

  // --- Table ---
  const tableStartY = Math.max(70, companyStartY + 24);

  const tableBody = saleItems.map((r, i) => [
    i + 1,
    r.items,
    r.qty,
    r.priceItem,
    r.totalAmount,
  ]);

  const subtotal = soldItemData?.billAmount;

  tableBody.push([
    {
      content: "SUBTOTAL",
      colSpan: 4,
      styles: {
        halign: "center",
        fontStyle: "bold",
        fillColor: [249, 173, 164],
      },
    },
    {
      content: subtotal,
      styles: {
        halign: "center",
        fontStyle: "bold",
        fillColor: [249, 173, 164],
      },
    },
  ]);

  doc.autoTable({
    head: [["S.No", "ITEMS", "QTY", "Price Per Item", "AMOUNT"]],
    body: tableBody,
    startY: tableStartY,
    margin: { left: 15, right: 15 },
    headStyles: {
      fillColor: [249, 173, 164],
      halign: "center",
      textColor: [0, 0, 0],
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    bodyStyles: {
      halign: "center",
      fontSize: 8,
      textColor: [0, 0, 0],
    },
    styles: {
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { cellWidth: 12 }, // S.No
    },
  });

  // --- Footer ---
  let finalY = doc.lastAutoTable.finalY + 10;
  if (finalY + 36 > pageHeight) {
    doc.addPage();
    finalY = 20;
  }

  doc.setFontSize(10).setFont("helvetica", "bold")
    .text(`TOTAL AMOUNT: ${soldItemData?.billAmount}`, 15, finalY);

  const label = "Total Amount (in words): ";
const value = convertNumberToWords(soldItemData?.billAmount);

// First print label in normal style
doc.setFontSize(9).setFont("helvetica", "normal").text(label, 15, finalY + 6);

// Measure the width of the label to align the value right after it
const labelWidth = doc.getTextWidth(label);

// Now print value in bold style at the correct X position
doc.setFont("helvetica", "bold").text(value, 15 + labelWidth, finalY + 6);


// Round stamp at bottom-right (as circular image)
await addImageFromUrl(
  doc,
  companyInfo.schoolStamp && `data:image/jpeg;base64,${companyInfo.schoolStamp}`,
  pageWidth - 45,
  finalY - 3,
  25,
  25,
  true // Enable circular clipping
);

  // Text below the stamp
doc.setFontSize(8)
   .setFont("helvetica", "bold")
   .text(`Authorized Stamp for ${companyInfo?.schoolName || "N/A"}`, pageWidth - 45, finalY + 30, {
     maxWidth: 100,
     align: "center"
   });

  // Save PDF
  doc.save(`${soldItemData?.studentFirstName} ${soldItemData?.studentFirstName}_BillReceipt.pdf`);
};



  /* ──────────────────────────────────────────────────────────── */

  return (
    <Grid container justifyContent="center" mt={7} >
      {/* toolbar */}
      <Grid item xs={12} md={10}>
        <Card sx={{ p: 2, mb: 3 }}>

          <Grid container alignItems="center">
            <Grid item xs>
              <Box display="flex"  sx={{ marginBottom: '20px' }}>
          <ArrowBackIcon
            sx={{
              color: '#1976d2',
              marginRight: '8px',
              marginTop:'7px',
              cursor:'pointer'
            }}
            onClick={ () => navigate(-1)}
          />
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#333',
            }}
          >
            {soldItemData?.studentFirstName || "N/A"} {soldItemData?.studentLastName || ""}/ Bill No #{soldItemData?.billNo}


          </Typography>
        </Box>
            </Grid>
            <style>
  {`
    @media print {
      @page {
        margin: 0;
      }

      body {
        margin: 0 !important;
        padding: 0 !important;
      }

      .print-container {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  `}
</style>




            <Grid item>
              {/* <Button
                variant="contained"
                startIcon={<PrintIcon />}
                sx={{ mr: 1 }}
                onClick={handlePrint}
              >
                Print
              </Button>
              <Button
                variant="contained"
                color="error"
                startIcon={<DownloadIcon />}
                // onClick={handleDownload}
                 onClick={() => handleDownload(soldItemData,saleItems, companyInfo)} // ✅ Proper call
                
              >
                PDF
              </Button> */}




  <Button
              onClick={handlePrint}
              variant="contained"
              startIcon={<PrintIcon />}
              sx={{
                backgroundColor: '#1976d2',
                color: '#fff',
                marginRight:'10px',
                fontSize: '11px',
                fontWeight: 'bold',
                padding: '8px 18px',
                borderRadius: '8px',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s, background-color 0.3s',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  transform: 'translateY(-3px)',
                },
              }}
              
            >
              Print Receipt
            </Button>

            {/* Download Button */}
            <Button
               onClick={() => handleDownload(soldItemData,saleItems, companyInfo)} // ✅ Proper call
              variant="contained"
              startIcon={<DownloadIcon />}
              sx={{
                backgroundColor: '#e53935',
                color: '#fff',
                fontSize: '11px',
                fontWeight: 'bold',
                padding: '8px 18px',
                borderRadius: '8px',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.2s, background-color 0.3s',
                '&:hover': {
                  backgroundColor: '#d32f2f',
                  transform: 'translateY(-3px)',
                },
              }}
            >
              Download Receipt
            </Button>
















            </Grid>
          </Grid>
        </Card>
      </Grid>

      {/* printable content */}
      <Grid item xs={12} md={10}>
        <Box
          ref={componentRef}
          sx={{
            width: "210mm",
            p: 3,
            backgroundColor: "#fff",
    //         '@media print': {
    //   p: 0, // Remove padding in print
    //   margin:0
    // }
          }}
        >
          {/* ─ Header (kept together) ─ */}
          <Box >
            <Typography align="center" fontWeight="bold" mb={2}>
              Bill Receipt
            </Typography> 

 {/* Logo + School Info in row */}
<Grid container alignItems="center" spacing={-10}>
  {/* Logo - Left */}
  <Grid item > {/* small padding to the right of the logo */}
    <img
      src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
      alt="logo"
      style={{
        width: 100,
        height: 100,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  </Grid>

  {/* School Info - Centered horizontally */}
  <Grid item xs >
    <Box>
      <Box textAlign="center">
        <Typography variant="h6" fontWeight="bold" color="error">
          {companyInfo.schoolName}
        </Typography>
        <Typography>
          {[companyInfo.schoolAddress, companyInfo.city].filter(Boolean).join(', ')}
        </Typography>
        <Typography>
          {[companyInfo.state, companyInfo.pincode].filter(Boolean).join(', ')}
        </Typography>
        <Typography>
          {companyInfo.schoolEmailId}, {companyInfo.primaryContact}
        </Typography>
      </Box>
    </Box>
  </Grid>
</Grid>


<Box mt={2}>
  <Grid
    container
    sx={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "nowrap", // Prevent wrapping in print
      '@media print': {
        flexWrap: 'nowrap', // Ensure side-by-side in print
      },
    }}
  >
    {/* Company Details - Left */}
    <Grid item sx={{ width: '50%' }}>
      <Typography variant="h6" fontWeight="bold">
        Student Details:
      </Typography>
      <Typography>
        Student Name: {`${soldItemData?.studentFirstName || ""} ${soldItemData?.studentLastName || ""}`}
      </Typography>
      {board === "INTERMEDIATE" && (

       <Typography>
       Course: {soldItemData?.course || "-"}
      </Typography>
      )}
      <Typography>
       Class: {soldItemData?.romanNumberClass || "-"}
      </Typography>
      <Typography>
       Section: {soldItemData?.sections || "-"}
      </Typography>
    </Grid>

    {/* Bill Details - Right */}
    <Grid item sx={{ width: '45%' }}>
      <Box>
        <Typography variant="h6" fontWeight="bold">
          Bill Details:
        </Typography>
        <Typography>
          Bill No: {soldItemData?.billNo}
        </Typography>
        <Typography>
          Bill Date: {soldItemData?.date}
        </Typography>
      </Box>
    </Grid>
  </Grid>
</Box>




          </Box>

          {/* ─ Table (single, continuous) ─ */}
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table size="small">
              <TableHead sx={{ background: "#F9ADA4" }}>
                <TableRow>
                  {["S.No", "ITEMS", "QTY", "Price Per Item", "AMOUNT"].map(h => (
                    <TableCell
                      key={h}
                      sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center",fontWeight: "bold"  }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {saleItems?.map((row, i) => (
  <TableRow key={i}>
    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      {i + 1}
    </TableCell>
    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      {row.items}
    </TableCell>
    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      {row.qty}
    </TableCell>
    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      ₹{row.priceItem}
    </TableCell>
    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
      ₹{row.totalAmount}
    </TableCell>
  </TableRow>
))}


                {/* subtotal row */}
                <TableRow sx={{ background: "#F9ADA4" }}>
                  <TableCell
                    colSpan={4}
                   sx={{borderRight: "1px solid #ddd",padding: "4px",textAlign: "center",fontWeight: "bold" }}
                   
                  >
                    SUBTOTAL
                  </TableCell>
                  <TableCell sx={{borderRight: "1px solid #ddd",padding: "4px",textAlign: "center",fontWeight: "bold" }}>
                    {/* ₹{subtotal} */}
                    ₹{soldItemData?.billAmount}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>


          <Box className="avoid-break" mt={3} sx={{ position: 'relative', minHeight: 150 }}>
  <Grid container justifyContent="space-between" alignItems="flex-start">
    <Grid item sx={{ maxWidth: '70%' }}>
      <Typography variant="h6" fontWeight="bold">
        TOTAL AMOUNT&nbsp;&nbsp;  ₹{soldItemData?.billAmount}

      </Typography>
      <Typography sx={{ mt: 1 }}>
        Total Amount (in words):{" "}
        <strong>{convertNumberToWords(soldItemData?.billAmount)}</strong>
      </Typography>
    </Grid>

    {/* Stamp container absolutely positioned to bottom-right */}
    <Box
      sx={{
        position: "absolute",
        bottom: 0,
        right: 0,
        textAlign: "center"
      }}
    >
      <img
        src={`data:image/jpeg;base64,${companyInfo.schoolStamp}`}
        alt="stamp"
        style={{ width: 100, height: 100, borderRadius: "50%" }}
      />
      <Typography fontWeight="bold">
        Authorized Stamp for {companyInfo?.schoolName}
      </Typography>
    </Box>
  </Grid>
</Box>

        </Box>
      </Grid>
    </Grid>
  );
}